export default __webpack_public_path__ + "static/404-a9426c6b7b391e0cb994c30a2fb1fa17.gif";